import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbConfigSkin } from 'app/abstract/full-pages/config-skin/config-skin.abstract';

import { ICOLOR, colorsTheme } from './colors';

@Injectable({ providedIn: 'root' })
export class ConfigSkinService extends AbConfigSkin {


  constructor(http: HttpClient) {
    super(http);
  }

  public getConfigSkin(): Observable<any> {
    return this.get(`public/config_skin/1`);
  }

  public getSkinCor(): Observable<any> {
    return this.get(`public/config_skin/skinconta/`);
  }

  public setThemeSkin(themeColor: string): void {
    colorsTheme.filter((item: ICOLOR) => {
      let theme = themeColor.toLocaleLowerCase() === item.color.toLocaleLowerCase() ? item.theme : 'default-theme'
      document.body.classList.toggle(theme, true)
    })
  }
}